import type { SelectInputOption } from '@/components/inputs/SelectInput';
import type { Control } from 'react-hook-form';
import { FormSelectInput } from '@/components';
import type {
  IntegrationRequestCodeRef,
  IntegrationRequestFormSchema,
} from '../../../../models/IntegrationRequest';
import FormSection from './FormSection';

const REQUEST_TYPE_OPTIONS: SelectInputOption[] = [
  { value: 'API', label: 'Integración por API' },
  { value: 'WEBHOOK', label: 'Solo webhook' },
];

interface RequestTypeSectionProps {
  control: Control<IntegrationRequestFormSchema>;
  commerce: IntegrationRequestCodeRef;
  operatorOptions: SelectInputOption[];
  disabled: boolean;
}

const RequestTypeSection = ({
  control,
  commerce,
  operatorOptions,
  disabled,
}: RequestTypeSectionProps) => (
  <FormSection
    title={
      <>
        {commerce.name}
        {commerce.code && (
          <span className='text-gray-500 font-normal'> · código {commerce.code}</span>
        )}
      </>
    }
  >
    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
      <FormSelectInput
        control={control}
        name='type'
        placeholder='Tipo de solicitud'
        options={REQUEST_TYPE_OPTIONS}
        disabled={disabled}
        required
      />
      <FormSelectInput
        control={control}
        name='logisticOperatorId'
        placeholder='Operador logístico'
        options={operatorOptions}
        disabled={disabled}
        required
      />
    </div>
    {operatorOptions.length === 0 && (
      <p className='text-sm text-amber-700'>
        El comercio no está asociado a ningún operador logístico. Debe asociarlo antes de pedir la
        integración.
      </p>
    )}
  </FormSection>
);

export default RequestTypeSection;
